import { render, staticRenderFns } from "./DeleteVm.vue?vue&type=template&id=3c14c19b"
import script from "./DeleteVm.vue?vue&type=script&lang=js"
export * from "./DeleteVm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports